import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Modal from "./Modal";
import Button from "../Button/Button";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { closeProfileCompletionModal } from "@store/slices/modalSlice";

interface ProfileCompletionModalProps {
	isOpen: boolean;
}

const ProfileCompletionModal: React.FC<ProfileCompletionModalProps> = ({ isOpen }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleCompleteProfile = () => {
		dispatch(closeProfileCompletionModal());
		navigate(BROWSER_ROUTES.PROFILE_PERSONAL_INFO);
	};

	const handleClose = () => {
		dispatch(closeProfileCompletionModal());
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={handleClose}
			showCloseIcon
			width="max-w-md"
			padding="p-8"
			className="text-center">
			{/* Icon */}
			<div className="flex justify-center mb-6">
				<div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
					<svg
						className="w-8 h-8 text-yellow-600"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg">
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
						/>
					</svg>
				</div>
			</div>



			{/* Title */}
			<h2 className="text-xl font-bold text-gray-900 mb-3">{t("common.ui.completeAdmissionProfileTitle")}</h2>

			{/* Description */}
			<p className="text-gray-600 mb-8">{t("common.ui.completeAdmissionProfileDescription")}</p>

			{/* Action Button */}
			<Button
				text={t("common.ui.completeAdmissionProfileButton")}
				variant="primary"
				onClick={handleCompleteProfile}
				className="w-full py-3"
			/>
		</Modal>
	);
};

export default ProfileCompletionModal;

